import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import printJS from 'print-js'
import Printd from 'printd'
import Pagination from './../shared/pagination'
import inward from '../inward'
import inwardEdit from '../inwardEdit'
import GRC from '../GRC1'
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import GRClist from '../GRC/grclist'
import common_helper from '../../../common_helper'

export default {
	name: 'client',
	components: {
		//	Paginate,
		GRC,
		inwardEdit,
		inward,
		Pagination,
		DatePicker,
		Loader,
		BasicSelect,
		GRClist
	},
	data: function () {
		return {
			accordianTab: { 1: false },
			expanded: false,
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			pageLimit: 10,
			searchflag: false,
			totalRows: 0,
			// currentPage: 0,
			currentPage2: 1,
			//modalShow used for close the active/inactive modal(default)
			listInwardMasterData: [],
			listGRCData: [],
			listInwardDetailData: [],
			listInwardDetailData1: [],
			inwarddetailmodal: false,
			drno: '',
			grnno: '',
			invreferenceid: '',
			fromdate: '',
			todate: '',
			inwardid: '',
			drid: '',
			invoicevalue: '',
			po: '',
			merchant: '',
			drstatus: '',
			sapstatus: '',
			productarray: [],
			quantity: '',
			showmodal: false,
			isLoading: false,
			listMerchantData: [],
			listClientData: [],
			listWarehouseData: [],
			// pageCount: 0,
			// pageNo: 0,
			totalPageDetail: 0,
			pageNoDetail: 0,
			// pageLimit: 10,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showlist: true,
			showSelectClient: false,
			showSelectWarehouse: false,
			clientList: [],
			warehouseList: [],
			merchantList: [],
			ClientErr: '',
			WarehouseErr: '',
			item: {},
			merchant: '',
			listMerchantData1: [],
			merchantList: [],
			merchantname: '',
			loading: false,
			loadingText: '<i class="fa fa-spinner fa-spin"></i> Loading...',
			selectedRow: {},
			filterData: {},
			formattedDate: '',
			only_notinwarded: false,
			checkedNames: [],
			baseUrl: apiUrl.api_url,
			closeDRModal : false,
			drListingModal:false,
			dataDRNumber:'',
			dataPONumber:'',
			dataDRListing:[],
			dataViewDRListing:[],
			closeDrObj : {
				 inwardid : '',
				 clientid : '',
				 warehouseid : '',
				 invreferenceid : ''

			},
          useremail : '',
			roleId:'',
			closedrFlag : false,
			searchSLA :'',
			slaclient:[],
			slaflag:false,
			clientview:1,
			hideGRNExcessQtyFlag:false,
            hideGRNExcessQty:0,
			clientviewInvoice: 0
		}
	},
	beforeCreate: function () {
		this.isLoading = true;
	},

	created: function () { },
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY');
		},
		date_time: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}

	},
	// when a page loads,mounted() will be call
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var innerpermissionEncrypt = window.localStorage.getItem('innerpermissiondata')
		var innerbytes = CryptoJS.AES.decrypt(innerpermissionEncrypt.toString(), 'Key');
		var innerplaintext = innerbytes.toString(CryptoJS.enc.Utf8);
		var innerdetail = JSON.parse(innerplaintext);
		this.getComponentPermission(innerdetail);
		this.roleId = userdetail.roleid;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if(this.clientid!=='undefined'){
			this.getMerchantList();
			this.getClientList();
		}


		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
        this.useremail = userdetail.email;
		this.user_type = userdetail.utype;
		var slaconfig = window.localStorage.getItem('slaconfig');
		this.slaclient = JSON.parse(slaconfig);
		console.log(this.slaconfig);

		this.slaflag = this.slaclient.some(item => {
			if (item.clientid == this.clientid) {
			  return true;
			} else {
			  this.slaflag = false;
			  return false;
			}
		  });


		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.clientviewInvoice = 1;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantList();
				this.showSelectWarehouse = true;
				this.clientviewInvoice = 1;
				this.clientview = 0
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.clientviewInvoice = 1;
				// this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	},
	methods: {
		async updateexpiredInvoice(data) {
            let currentDate = new Date();
            this.invoiceExpiry = new Date(data.expirydate);
            if (this.invoiceExpiry && currentDate.getTime() > this.invoiceExpiry.getTime()) {
                this.isinvoiceexpired = 1;
            }
            if (this.isinvoiceexpired) {
                this.input = ({
                    clientid: this.clientid,
                    isinvoiceexpired: this.isinvoiceexpired,
                    invreferenceid: data.invreferenceid,
                    invoiceurl: this.baseUrl.concat(this.clientid, '/tiny/', data.shorturl),
                    invoiceid: data.invoiceurlid
                });
                let result = await common_helper.getRestApiResponse('POST', 'updateInvoiceUrlCounter', this.input, this.$alertify)
                if (result.data.status) {
                    this.$alertify.success(result.data.msg)
                    this.getInwardMasterSearch()
                    this.isinvoiceexpired = 0;
                } else {
                    this.$alertify.error(result.data.msg)
                    this.isinvoiceexpired = 0;
                }
            }
        },
		notinwarded(ev) {


			this.only_notinwarded = document.getElementById("only_notinwarded1").checked


		},
		getComponentPermission(innerdetail) {
			var component = 'inwardlist';
			var innerpermArr = {};
			for (var i = 0; i < innerdetail.length; i++) {
				if (innerdetail[i].controllerurl == component) {
					innerpermArr = innerdetail[i].permission;
					break;
				}
			}
			if (JSON.stringify(innerpermArr) == 'null') {
				//alert("wrong");
			} else {
				//console.log(innerpermArr);
				for (var i = 0; i < innerpermArr.length; i++) {
					if (innerpermArr[i].id == 'closedr') {
						this.closedrFlag = true;
					}

				}
			}

		},

		showAddForm(data) {
			this.selectedRow = data
			this.showlist = false;
		},
		showgrcForm(data) {
			this.selectedRow = data
			this.showlist = 'GRC';
		},
		callParent() {
			this.showlist = true;
		},
		showgrcList(data) {
			this.selectedRow = data
			this.showlist = 'GRCList';
		},
		toggleCheck(tabid) {
			// this.expanded = false;
			for (var key in this.accordianTab) {
				if (tabid != key) {
					this.accordianTab[key] = false;
				}
			}
			this.onclick();

		},
		onclick() {
			if (this.expanded == false) {
				this.expandAll()
				this.expanded = true;
			} else {
				this.collapseAll()
			}
		},
		reset() {
			this.item = {}
		},
		onSelect(item) {

			this.item = item
			this.merchant = item.value
		},

		// async getWarehouseList() {
		// 	this.pageNo = this.pageCount = 0;

		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});
		// 	let result = await common_helper.getRestApiResponse('POST', 'getClientAssociatedWarehouseList', this.input, this.$alertify)
		// 	if (result && !result.errorDATA) {
		// 		if (result.data.data && result.data.data.length > 0) {
		// 			this.listWarehouseData = result.data.data;
		// 			var warehouseListArray = [];
		// 			result.data.data.forEach(function (item) {
		// 				warehouseListArray[item.warehouseid] = item.warehousename;
		// 			});
		// 			this.warehouseList = warehouseListArray;
		// 		}
		// 	}

		// },

		async getClientList() {
			if (window.localStorage.getItem("clientList") !== null) {
				var clientListEncrypt = window.localStorage.getItem('clientList');
				var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
				var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
				var clientList = JSON.parse(plaintextclient);
				var clientListArray = [];
				clientList.forEach(function (item) {
					clientListArray[item.clientid] = item.clientname;
				});
				this.clientList = clientListArray;
				this.listClientData = clientList;
			} else {
				this.pageNo = this.pageCount = 0;

				this.input = ({
					warehouseid: this.warehouseid,
				});
				let result = await common_helper.getRestApiResponse('POST', 'getWarehouseAssociatedClientList', this.input, this.$alertify)
				if (result && !result.errorDATA) {
					if (result.data.data && result.data.data.length > 0) {
						this.listClientData = result.data.data;

						var clientListArray = [];
						result.data.data.forEach(function (item) {
							clientListArray[item.clientid] = item.clientname;
						});

						this.clientList = clientListArray;
					}
				}

			}
		},


		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchant = '';
		// 		//this.totalRows=[]
		// 		if (this.clientid)
		// 			this.item = {}
		// 		this.getMerchantList();

		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();

		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			// this.getCancelPutAwayPendingData();
		// 		}
		// 	}
		// 	this.listInwardMasterData = [];
		// 	this.pageNo = this.pageCount = 0;
		// 	this.totalRows = 0;
		// },

		// warehouseSelected() {
		// 	this.totalRows = 0
		// 	this.warehouseid = this.warehouse;
		// 	this.pageNo = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getCancelPutAwayPendingData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		async getMerchantList() {
			this.listMerchantData1 = []
			this.input = ({
				clientid: this.clientid,
			})
			let result = await common_helper.getRestApiResponse('POST', 'merchantList', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				if (result.data && result.data.length > 0) {
					this.listMerchantData = result.data;
					var merchantlistArray = [];
					this.item = {
						value: '',
						text: ''
					};
					this.listMerchantData1 = [{
						value: '',
						text: this.$t('common.merchantPlaceholder')
					}];
					result.data.forEach(function (item) {
						merchantlistArray[item.merchantid] = item.merchantname;

					})
					this.merchantList = merchantlistArray;
					this.listMerchantData.forEach(ele => {
						this.listMerchantData1.push({
							"value": ele.merchantid,
							"text": ele.merchantname
						})
					})

				}
			}

		},
		getInwardMasterSearch() {
			this.currentPage = 1;
			this.searchflag = true;
			this.getInwardMasterData();
		},

		//to get inward master data
		async getInwardMasterData() {



			if (window.localStorage.getItem('selectedClient') === 'undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.pageCount = 0;
				this.listInwardMasterData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse') === 'undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.pageCount = 0;
				this.listInwardMasterData = [];
				return false;
			}
			var fr_date = '';
			var to_date = '';

			if (this.fromdate != '') {
				fr_date = this.dateFormat(this.fromdate, 1)
			}
			if (this.todate != '') {
				to_date = this.dateFormat(this.todate, 2)
			}

			this.isLoading = true;
			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				invreferenceid: this.invreferenceid,
				fromddate: fr_date,
				todate: to_date,
				invoicevalue: this.invoicevalue,
				supplier: this.merchant,
				drstatus: this.drstatus,
				sapstatus: this.sapstatus,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				po: this.po,
				only_notinwarded: this.only_notinwarded,
				slastatus:this.searchSLA
			});
			this.filterData = this.input
			let result = await common_helper.getRestApiResponse('POST', 'getMaterialInwardMaster', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				this.isLoading = false;
				this.listInwardMasterData = result.data.rows;
				this.totalRows = Number(result.data.count);
				// this.setDataPageCounts(result.data.count);
				if (this.totalRows > 0) {
					if (this.totalRows <= this.pageLimit) {
						this.totalPage = 1;
					} else {
						this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
					}
				} else {
					this.totalPage = 0;
				}
			}

		},

		//to get client list
		getInwardMasterDataSearch() {
			this.pageNo = this.pageCount = 0;
			this.getInwardMasterData();
		},

		getGRCListdetails(data) {
			this.showlist = 'GRCList'
			this.selectedRow = data

		},

		//open new form(popup)
		async getInwardetails(data) {
			this.inwarddetailmodal = true;
			this.expanded = false,
				this.inwardid = data.inwardid;
			this.drno = data.inwardid;
			this.listGRCData = []
			this.collapseAll()


			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				inwardid: data.inwardid.trim(),
				offset: (this.currentPage2 - 1) * 10,
				limit: this.pageLimit,
			});
			let result = await common_helper.getRestApiResponse('POST', 'getMaterialInwardDetails', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				await this.getClientId(data)
				await this.getSerachGRCOnDR(data)
				var clientList = [],
					merchantList = [];
				for (var i = 0; i < this.listClientData.length; i++)
					clientList[this.listClientData[i].clientid] = this.listClientData[i].clientname;

				for (var i = 0; i < this.listMerchantData.length; i++)
					merchantList[this.listMerchantData[i].merchantid] = this.listMerchantData[i].merchantname;

				var inwardDetailData = [];
				if (result.data.length > 0) {
					result.data.forEach(function (item) {
						item["clientname"] = item["merchantname"] = '';
						if (item.clientid && clientList[item.clientid]) {
							item["clientname"] = clientList[item.clientid];
						}
						if (item.merchantid && merchantList[item.merchantid]) {
							item["merchantname"] = merchantList[item.merchantid];
						}
						inwardDetailData.push(item);
					});
				}
				this.listInwardDetailData = inwardDetailData;
				this.listInwardDetailData1 = this.listInwardDetailData[0]
				this.totalCount = result.data.count;
				if (this.totalCount > 0) {
					if (this.totalCount <= this.pageLimit) {
						this.totalPageDetail = 1;
					} else {
						this.totalPageDetail = Math.ceil(this.totalCount / this.pageLimit);
					}
				} else {
					this.totalPageDetail = 0;
				}
			}


			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.input2=({
				clientid:window.localStorage.getItem("selectedClient"),
				warehouseid:window.localStorage.getItem("selectedWarehouse"),
				drno:data.invreferenceid,
				pono:data.pono
			})
			await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getGRNDetailsToClose',
				'data': this.input2,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
			.then(result => {
				if (result.data.status) {
				   this.dataDRListing=result.data.data
				   this.dataViewDRListing=this.dataDRListing[0]
				}else{
				   this.dataDRListing=[]
				   this.dataViewDRListing=[]
				}
			}, error => {
				console.error(error);
			})

		},

		editDR(data) {
			this.selectedRow = data
			this.showlist = 'EDIT';

		},
		closeDRSave()
		{

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'saveCloseDR',
					'data': {
						'useremail': this.useremail,
						'inwardid' : this.closeDrObj.inwardid,
						'clientid' : this.closeDrObj.clientid,
						'warehouseid' : this.closeDrObj.warehouseid,
						'invreferenceid' : this.closeDrObj.invreferenceid,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.$alertify.success(response.data.msg);
						this.addusermodal = false;
						this.getInwardMasterData();
					} else if (response.data.errorCode == -1) {
						this.$alertify.error(response.data.msg);
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		closeStatusDRModal()
		{
			 this.closeDRModal = false;
		},
        closeDRListingModal(){
           this.drListingModal = false;
		},
		showDRCloseConfirmation(data) {

		        this.closeDrObj.inwardid = data.inwardid;
		        this.closeDrObj.clientid = data.clientid;
		        this.closeDrObj.warehouseid = data.warehouseid;
		        this.closeDrObj.invreferenceid = data.invreferenceid;
				this.dataDRNumber=data.invreferenceid;
				this.dataPONumber=data.pono;

						if(data.pono === null)
						{
							 this.$alertify.error("DR Cannot Be Closed, As No PO Is Mapped");
							 return false;
						}
            else {
							var userToken = window.localStorage.getItem('userToken');
						 var myStr = userToken.replace(/"/g, '');

						 axios({
							 method: 'POST',
							 'url': apiUrl.api_url + 'validateCloseDR',
							 'data': {
								 'pono': data.pono,
								 'inwardid' : this.closeDrObj.inwardid,
								 'clientid' : this.closeDrObj.clientid,
								 'warehouseid' : this.closeDrObj.warehouseid,
								 'invreferenceid' : this.closeDrObj.invreferenceid,
							 },
							 headers: {
								 'Authorization': 'Bearer ' + myStr,
							 }
						 })
						 .then(async (response) => {
							 if (response.data.errorCode == 0) {
								 //this.$alertify.success(response.data.msg);
								 this.closeDRModal = true

							 } else if (response.data.errorCode == -1) {
								 this.drListingModal = true;
								 this.input={
									clientid:window.localStorage.getItem("selectedClient"),
									warehouseid:window.localStorage.getItem("selectedWarehouse"),
									pono:this.dataPONumber,
									drno:this.dataDRNumber
								}
								 await axios({
									method: 'POST',
									'url': apiUrl.api_url + 'getGRNDetailsToClose',
									'data': this.input,
									headers: {
										'Authorization': 'Bearer ' + myStr
									}
								})
								.then(result => {
									if (result.data.status) {
									   this.dataDRListing=result.data.data
									}else{
									   this.dataDRListing=[]
									}
								}, error => {
									console.error(error);
								})
								 this.$alertify.error(response.data.msg);
							 }
						 })
						 .catch((httpException) => {
							 console.error('exception is:::::::::', httpException)
						 })
            }

		    },


		getSerachGRCOnDR(data) {
			return new Promise(async (resolve, reject) => {
				this.inwardid = data.inwardid;

				if (this.$route.query.drno) {
					this.$router.push({
						path: '/GRClist',
						query: {}
					})
				}
				this.isDrfound = false;
				this.DRerrors = '';

				this.input = ({
					drno: data.invreferenceid,
					warehouseid: window.localStorage.getItem('selectedWarehouse'),
					clientid: this.clientid
				});
				this.isLoading = true;
				let result = await common_helper.getRestApiResponse('POST', 'getSerachGRCOnDR', this.input, this.$alertify)
				if (result && !result.errorDATA) {
					if (result.data.message == "") {
						this.isDrfound = true;
						this.listGRCData = result.data.result.data;
						this.GRCCounts = result.data.result.counts;

					} else {
						this.DRerrors = result.data.message;
					}
					this.isLoading = false;
				}
				resolve(true)
			})
		},
		async getClientId(data) {
			return new Promise(async (resolve, reject) => {
				this.inwardid = data.inwardid;
				this.drno = data.inwardid


				if (this.drno == "") {
					this.DRerrors = this.$t('grcList.drError');
					return false;
				}
				this.isLoading = true;
				this.input = ({
					'invreferenceid': data.invreferenceid.trim(),
				});
				let result = await common_helper.getRestApiResponse('POST', 'searchDR', this.input, this.$alertify)
				if(result.data.hideGRNExcessQty!==undefined){
					this.hideGRNExcessQtyFlag=true;
					this.hideGRNExcessQty=result.data.hideGRNExcessQty
				}else{
					this.hideGRNExcessQtyFlag=false;
				}

				if (result && !result.errorDATA) {
					this.isLoading = false;
					if (result.data.data.clientid) {
						this.clientid = result.data.data.clientid;
						// this.getSerachGRCOnDR();
					} else {
						// this.getSerachGRCOnDR(data);
						this.isLoading = false;
						this.GRCCounts = {}
						this.isDrfound = false
						this.listGRCData = [];
						this.DRerrors =  result.data.msg;
					}

				}
				this.isLoading = false;
				resolve(true)
			})
		},

		resetFlt() {
			this.only_notinwarded = false;
			this.searchSLA='';
			this.totalRows = 0
			this.drstatus = '';
			this.sapstatus = '';
			this.invreferenceid = '';
			this.fromdate = '';
			this.todate = '';
			this.merchant = '';
			this.po = '';
			this.invoicevalue = '';
			this.pageNo = this.pageCount = 0;
			this.pageNoDetail = this.pageCountDetail = 0;
			this.listInwardMasterData = [];
			this.listInwardDetailData = [];
			this.item = {}
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},

		//to close the Inward Details popup
		closeInwardDetailModal() {
			this.inwarddetailmodal = false
		},

		//to open the Inward Details popup
		openmodal(data) {
			this.quantity = '';
			document.getElementById('quantity').value = '';
			this.showmodal = true;
			this.quantity = '';
			this.$validator.reset();
			this.errors.clear();
			this.productarray = data;
		},
		expandAll() {
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll() {
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},

		closemodal() {
			this.$validator.reset();
			this.errors.clear();
			this.showmodal = false;
		},

		submitprint() {
			if (this.quantity == '' || this.quantity == null) {
				return false;
			}
			var qty = this.quantity;
			var drno = this.productarray.invreferenceid;
			var clientid = this.productarray.clientid;
			var merchantid = this.productarray.merchantname;
			var invoiceno = this.productarray.challanno;
			var poid = this.productarray.pono;
			var drdate = this.productarray.createddate;
			var matdesc1 = this.productarray.materialdesc;
			var matdesc2 = '';

			var clientObj = this.listClientData.filter(function (arr) { return arr.clientid == clientid })[0];

			this.printproduct(drno, clientObj.clientname, merchantid, invoiceno, poid, drdate, matdesc1, matdesc2, qty);
		},
		print() {
			if (this.expanded == true) {
				document.getElementById("headerpd").style.display = "";
			}
			this.printfun = true;
			const d = new Printd();
			var buffer = '';

			var cssText = `
   body{
  -webkit-print-color-adjust:exact;
}
   .tableone {
       border-collapse: collapse;
	  margin-left:0px !important;

   }
   table {
	border-collapse: collapse;
   margin-left:0px !important;

  }
   .tabletwo{
	border-collapse: collapse;
	float:right;
	margin-left:0px !important;
	margin-top:-307px !important;

   }

   table, th {

     border-style: solid;
border-width: 1px;
font: 14px/1.5 'Helvetica Neue', Helvetica, Arial, 'Microsoft Yahei', sans-serif;
font-weight: bold;
margin-bottom: 10px;
border-color: rgba(0,0,255,0.25);
       padding:5px;
   }

   #headerpd{
	display:""
   }
 td{
	border-style: solid;
	border-width: 1px;
	font: 14px/1.5 'Helvetica Neue', Helvetica, Arial, 'Microsoft Yahei', sans-serif;
	margin-bottom: 10px;
	border-color: rgba(0,0,255,0.25);
		   padding:5px;
 }
 pre {
   color: #c7254e;
 }
 .text-right{
   text-align:right;
 }
 .tab-label{
	 display:none;
 }
 #chck1{
	display:none;

 }
 .close{
	display:none;

 }

 .clientdetails{
   margin-top:-40px;
   font-size:12px;
 }
 .card-header{
	font-size:20px !important;

	font: 14px/1.5 'Helvetica Neue', Helvetica, Arial, 'Microsoft Yahei', sans-serif;

 }
 @media print {
 .text-primary th{
   background-color:rgb(226, 216, 216) !important;
   color:black !important;
   font-size:20px !important;
   font: 14px/1.5 'Helvetica Neue', Helvetica, Arial, 'Microsoft Yahei', sans-serif;

 }

}
`
			d.print(document.getElementById('printPoContent'), cssText);
			if (this.expanded == true) {
				document.getElementById("headerpd").style.display = "none";
			}
		},
		printPurchaseOrder() {
			printJS({
				printable: 'printPoContent',
				type: 'html',
				onLoadingStart: this.onLoadingStart,
				onLoadingEnd: this.onLoadingEnd
			});
		},
		onLoadingStart() {
			this.loading = true;
		},
		onLoadingEnd() {
			this.loading = false;
		},

		printproduct(drno, clientid, merchantid, invoiceno, poid, drdate, matdesc1, matdesc2, qty) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				clientid: clientid,
				merchantid: merchantid,
				drno: drno,
				invoiceno: invoiceno,
				poid: poid,
				drdate: this.dateFormat(drdate),
				matdesc1: matdesc1,
				matdesc2: matdesc2,
				qty: qty
			});

			axios({
				method: 'POST',
				'url': apiUrl.local_printer_api_url + 'printer/printdr',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data.code == 200) {
						this.$alertify.success(this.$t('grcList.validDrError'));
						this.quantity = '';
						this.closemodal();
					} else {
						this.$alertify.console.error();
						("Failed to print.");
						this.quantity = '';
						this.closemodal();
					}
				}, error => {
					console.error(error)
					this.$alertify.error(this.$t('inwardList.somethingWentWrong'));
					this.showmodal = false;
				})
		},

		//Sets total number of pages
		// setDataPageCounts(total_rows) {
		// 	if (total_rows > 0) {
		// 		if (total_rows <= this.pageLimit) {
		// 			this.pageCount = 1;
		// 		} else {
		// 			this.pageCount = Math.ceil(total_rows / this.pageLimit);
		// 		}
		// 	} else {
		// 		this.pageCount = 0;
		// 	}
		// },

		//Sets total number of pages
		// setDetailPageCounts(total_rows) {
		// 	if (total_rows > 0) {
		// 		if (total_rows <= this.pageLimit) {
		// 			this.pageCountDetail = 1;
		// 		} else {
		// 			this.pageCountDetail = Math.ceil(total_rows / this.pageLimit);
		// 		}
		// 	} else {
		// 		this.pageCountDetail = 0;
		// 	}
		// },

		//Call page number from pagination for inward master data
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.pageLimit;
		// 	this.getInwardMasterData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getInwardMasterData()
		},
		//Call page number from pagination for inward details
		// getPaginationDataDetail(currentPage2) {
		// 	this.pageNoDetail = (currentPage2 - 1) * this.pageLimit;
		// 	this.getInwardetails();
		// },
		getPaginationDataDetail(page) {
			this.currentPage = page;
			this.getInwardetails()
		},

		dateFormat(date, type) {
			if (!date) return '';

			if (type == 1) {
				return moment(date).format('YYYY-MM-DD 00:00:00');
			} else if (type == 2) {
				return moment(date).format('YYYY-MM-DD 23:59:00');
			} else {
				return moment(date).format('YYYY-MM-DD');
			}
		},

		//validate all form fields on onsubmit()
		onSubmit: function (event) {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
				event.target.reset();
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/inwardlist/inwardlist.component.js